import { createFileRoute } from "@tanstack/react-router";
import { VilkårPage } from "@/features/landing/VilkårPage";

export const Route = createFileRoute("/_public/_landing/vilkår")({
  component: VilkårPage,
  head: () => ({
    meta: [
      {
        title: "Vilkår | Selskapsportal for fjernvarme",
      },
    ],
  }),
});
